import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Router } from 'express';
import { ApiServicesService } from '../services/api-services.service';
import { SnackbarService } from '../services/snackbar.service';
import { UserDetailsService } from '../services/user-details.service';
import { TruncatePipe } from '../truncate.pipe';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-view-details',
  standalone: true,
  imports: [TruncatePipe, CommonModule],
  templateUrl: './view-details.component.html',
  styleUrl: './view-details.component.css'
})

export class ViewDetailsComponent {

  constructor(private route: ActivatedRoute, private apiService: ApiServicesService, private snackbarService: SnackbarService) { };

  userData: any = '';
  loader: boolean = true;
  ngOnInit() {
    if (this.route.snapshot.params['username']) {
      this.apiService.viewOthersProfile(this.route.snapshot.params['username']).subscribe({
        next: (response) => {
          this.loader = false;
          this.userData = response.user;
        },
        error: (err) => {
          this.snackbarService.openCustomSnackbar(
            {
              icon: false,
              message: err.error.message,
              className: 'failed',
            }
          );
        },
      });
    }
  }
}
